<template>
	<section class="section popular-caregories" ref="results">
		<div class="container mx-auto px-4">
			<div class="section-title__wrapper mb-4">
				<h3 class="section-title">Popular Caregories (TODO: Needs Data)</h3>
			</div>

			<div class="popular-caregories-cards">
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">Female led organisations</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">Top B Corp organisations</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">Climate game changers</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">10 organisations caring for our oceans</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">Top fem tech organisations</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">10 organisations that allow you to work anywhere in the world</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">Off-grid organisations</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">10 organisations that prioritise mental wellbeing of their employees</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
				<a href="#">
					<div class="popular-caregories-card">
						<div class="popular-caregories-card__img">
							<img src="https://placeimg.com/100/150/animals" alt="">
						</div>
						<div class="popular-caregories-card__body">
							<p class="popular-caregories-card__title">10 organisations paving the way in education</p>
							<div class="popular-caregories-card__footer">
								<p>View</p>
								<svg-arrow-extra-long></svg-arrow-extra-long>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
	</section>
</template>
